import { MarketDataMarket } from './market-data.model';

/** The only market Kala lists. */
export const KALA_MARKET: MarketDataMarket = 'Deposit';

/**
 * Bump whenever {@link SymbolInfo} changes shape: a cache written under another version is
 * dropped rather than read.
 */
export const SYMBOL_INFO_CACHE_VERSION = 1;

export const SYMBOL_INFO_STORAGE_KEY = `kala-symbol-info:${KALA_MARKET}`;

/** How long `market-view` may take before the list is shown without session figures. */
export const MARKET_VIEW_TIMEOUT_MS = 10_000;

export const MARKET_DATA_MARKETS: readonly MarketDataMarket[] = ['None', 'Future', 'Option', 'Deposit', 'General'];
